var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-4",attrs:{"disabled":_vm.isDisabled,"color":"primary","text":""},on:{"click":_vm.copy}},[_c('v-icon',[_vm._v(" mdi-content-copy ")]),_vm._v(" Copy ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }